import {
  notificationTemplateDetailSchema,
  notificationTemplateListResponseSchema,
  notificationTemplateMutationResponseSchema,
  notificationTemplatePreviewResponseSchema,
  type CreateNotificationTemplateDto,
  type NotificationTemplateDetail,
  type NotificationTemplateListResponse,
  type NotificationTemplateMutationResponse,
  type NotificationTemplatePreviewResponse,
  type PreviewNotificationTemplateDto,
  type UpdateNotificationTemplateDto,
} from '@control-center/shared';

import { apiClient } from './api-client';

export interface TemplateListFilter {
  channel?: 'whatsapp' | 'email';
  key?: string;
}

export async function fetchTemplates(
  filter: TemplateListFilter = {},
): Promise<NotificationTemplateListResponse> {
  const params = new URLSearchParams();
  if (filter.channel) params.set('channel', filter.channel);
  if (filter.key) params.set('key', filter.key);
  const qs = params.toString();
  const path = qs ? `/api/notification-templates?${qs}` : '/api/notification-templates';
  const res = await apiClient.get<unknown>(path);
  return notificationTemplateListResponseSchema.parse(res.data);
}

export async function fetchTemplateById(id: string): Promise<NotificationTemplateDetail> {
  const res = await apiClient.get<unknown>(`/api/notification-templates/${id}`);
  return notificationTemplateDetailSchema.parse(res.data);
}

export async function createTemplate(
  dto: CreateNotificationTemplateDto,
): Promise<NotificationTemplateMutationResponse> {
  const res = await apiClient.post<unknown>('/api/notification-templates', dto);
  return notificationTemplateMutationResponseSchema.parse(res.data);
}

export async function updateTemplate(
  id: string,
  dto: UpdateNotificationTemplateDto,
): Promise<NotificationTemplateMutationResponse> {
  const res = await apiClient.patch<unknown>(`/api/notification-templates/${id}`, dto);
  return notificationTemplateMutationResponseSchema.parse(res.data);
}

export async function previewTemplate(
  id: string,
  dto: PreviewNotificationTemplateDto,
): Promise<NotificationTemplatePreviewResponse> {
  const res = await apiClient.post<unknown>(`/api/notification-templates/${id}/preview`, dto);
  return notificationTemplatePreviewResponseSchema.parse(res.data);
}
